const groupActivityDetail = () =>
  import(
    /* webpackChunkName: "group~activity" */ 'page/platform/appCommunity/v2/groupActivityDetailV2.vue'
  )
const groupActivityTeamDetail = () =>
  import(
    /* webpackChunkName: "group~activity" */ 'page/platform/appCommunity/v2/groupActivityTeamDetailV2.vue'
  )
const groupActivityRanking = () =>
  import(
    /* webpackChunkName: "group~activity" */ 'page/platform/appCommunity/groupActivityRanking.vue'
  )

const participationTaskList = () =>
  import(
    /* webpackChunkName: "group~activity" */ 'page/platform/appCommunity/participationTaskList.vue'
  )

// 群任务详情
const groupTaskDetail = () =>
  import(
    /* webpackChunkName: "platform~groupTaskDetail" */ 'page/platform/appCommunity/v2/groupTaskDetailV2.vue'
  )

let routes = [
  {
    name: 'groupActivityDetail',
    path: '/group/activity',
    component: groupActivityDetail,
    meta: {
      pageName: '群活动详情页',
      business: '平台',
      title: '群活动详情页'
    }
  },
  {
    name: 'groupActivityTeamDetail',
    path: '/group/activity/team/:id',
    component: groupActivityTeamDetail,
    meta: {
      pageName: '群活动队伍详情页',
      business: '平台',
      title: '群活动队伍详情页'
    }
  },
  {
    name: 'groupActivityRanking',
    path: '/group/activity/ranking',
    component: groupActivityRanking,
    meta: {
      pageName: '群活动排行页',
      business: '平台',
      title: '群活动排行页'
    }
  },
  {
    name: 'participationTaskList',
    path: '/group/activity/taskList',
    component: participationTaskList,
    meta: {
      pageName: '我参与的群组队活动',
      business: '平台',
      title: '我参与的群组队活动'
    }
  },
  {
    path: '/appCommunity/groupTaskDetail/:taskId',
    name: 'groupTaskDetail',
    component: groupTaskDetail,
    meta: {
      pageName: '群任务详情',
      business: '平台',
      title: '群任务详情'
    }
  }
]

export default routes
